import { QueryClient } from '@tanstack/react-query';

/**
 * 전역 React Query 클라이언트.
 *
 * - staleTime 30s: 대부분의 분석 결과는 즉시 변하지 않는다.
 * - retry 1: 네트워크 일시 실패 방어. 장시간 파이프라인은 useQuery 옵션 override.
 * - refetchOnWindowFocus false: 무거운 오디오 분석 요청 중복 실행 방지.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
